export const getFilesFromEvent = (e: DragEvent | ClipboardEvent): FileList | undefined => {
	if ('dataTransfer' in e) {
		return e.dataTransfer?.files;
	}

	if ('clipboardData' in e) {
		return e.clipboardData?.files;
	}

	return undefined;
};

export const isTextPasteEvent = (e: ClipboardEvent) => {
	return !!e.clipboardData?.getData?.('Text');
};
